import styled from 'styled-components';

const ModalHeader = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-around;
  gap: 15px;
  z-index: 1;
  align-items: center;
  & > svg {
    color: #dee2e6;
    width: 30px;
    height: 30px;
  }
`;

const ModalTitle = styled.h1`
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -0.024em;
  color: #000000;
  margin: 0px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: auto;
  max-height: calc(100vh - 92px);
  width: calc(100% + 32px);
  margin-left: -16px;
  padding: 0px 16px;
  gap: 16px;

  & button {
    min-width: 100%;
  }
`;

const CardTitle = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.024em;
  color: #555a64;
`;

const CardDescription = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6c757d;
`;

const Image = styled.img`
  position: absolute;
  right: 0;
  top: 0;
`;

export { ModalTitle, ModalHeader, ModalContent, Image, CardTitle, CardDescription };
